import "./App.css";
import Fylo from "./pages/Fylo";

function App() {
  return <Fylo />;
}

export default App;
